import React from 'react';
import './DriftStatusBadge.css';

const STATUS_CONFIG = {
    stable: { label: 'Stable', icon: '✓' },
    changed: { label: 'Changed', icon: '△' },
    alert: { label: 'Alert', icon: '⚠' },
    unscanned: { label: 'Unscanned', icon: '—' }
};

function DriftStatusBadge({ status, size = 'default', showLabel = true }) {
    const config = STATUS_CONFIG[status] || STATUS_CONFIG.unscanned;

    return (
        <span
            className={`drift-badge drift-badge--${size}`}
            data-status={status || 'unscanned'}
            title={`Drift Status: ${config.label}`}
        >
            <span className="drift-badge__icon">{config.icon}</span>
            {showLabel && <span className="drift-badge__label">{config.label}</span>}
        </span>
    );
}

export default DriftStatusBadge;
